import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

import "../styles.scss";

const AccountsPayablePage = () => {
  const location = useLocation();

  useEffect(() => {
    if(location.hash) handleScrollToView(location.hash.slice(1))
  }, [location]);

  // ------------------ miscellaneous -------------------
  const handleScrollToView = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  };

  // stepper


const ColorlibStepIconRoot = styled('div')(({ theme }) => ({
  backgroundColor: '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  // ...theme.applyStyles('dark', {
  //   backgroundColor: theme.palette.grey[700],
  // }),
  variants: [
    {
      props: ({ ownerState }) => ownerState.active,
      style: {
        backgroundImage:
          'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
      },
    },
    {
      props: ({ ownerState }) => ownerState.completed,
      style: {
        backgroundImage:
          'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
      },
    },
  ],
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      <strong>
        {icons[String(props.icon)]}
      </strong>
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};


  return (
    <div dangerouslySetInnerHTML={{ __html: `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Accounts Payable | Lusid</title>
  <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;800&display=swap" rel="stylesheet">
  <style>
    :root {
      --blue-main: #0a66c2;
      --blue-dark: #004182;
      --blue-muted: #56687a;
      --blue-light: #dce6f1;
      --grey-main: #38434f;
      --grey-light: #e9e5df;
      --off-white: #fdfaf5;
      --white: #ffffff;
      --accent-green: #00c49a;
    }
    html, body {
      margin: 0;
      padding: 0;
      background: var(--white);
      color: var(--grey-main);
      font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
      // font-size: 18px;
      line-height: 1.6;
    }
    header {
      width: 100%;
      background: var(--white);
      position: sticky;
      top: 0;
      z-index: 100;
      border-bottom: 1px solid var(--grey-light);
    }
    .nav-container {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 18px 32px;
    }
    .logo img {
      height: 40px;
      display: block;
    }
    nav {
      display: flex;
      gap: 32px;
      align-items: center;
    }
    nav a {
      text-decoration: none;
      color: var(--grey-main);
      font-weight: 500;
      font-size: 1rem;
      padding: 6px 0;
      transition: color 0.15s;
    }
    nav a:hover {
      color: var(--blue-main);
    }
    .cta-nav {
      background: var(--blue-main);
      color: var(--white);
      border-radius: 20px;
      padding: 8px 22px;
      font-weight: 600;
      font-size: 1rem;
      margin-left: 12px;
      text-decoration: none;
      transition: background 0.15s;
      border: none;
      cursor: pointer;
    }
    .cta-nav:hover {
      background: var(--blue-dark);
    }
    .hero {
      background: var(--white);
      text-align: center;
      padding: 90px 20px 60px 20px;
      margin-bottom: 40px;
    }
    .hero h1 {
      font-size: 2.8rem;
      font-weight: 800;
      color: var(--blue-main);
      margin-bottom: 18px;
      letter-spacing: -1px;
    }
    .hero p {
      font-size: 1.25rem;
      color: var(--grey-main);
      margin-bottom: 38px;
      max-width: 600px;
      margin-left: auto;
      margin-right: auto;
    }
    .hero .cta-main {
      background: var(--blue-main);
      color: var(--white);
      border-radius: 24px;
      padding: 14px 38px;
      font-size: 1.1rem;
      font-weight: 700;
      border: none;
      cursor: pointer;
      margin: 0 10px;
      transition: background 0.15s;
      box-shadow: 0 2px 16px rgba(10,102,194,0.06);
    }
    .hero .cta-main:hover {
      background: var(--blue-dark);
    }
    .section {
      max-width: 1100px;
      margin: 0 auto 60px auto;
      padding: 0 24px;
    }
    .section-title {
      font-size: 2rem;
      font-weight: 700;
      color: var(--blue-main);
      text-align: center;
      margin-bottom: 36px;
      letter-spacing: -0.5px;
    }
    .ap-features-row {
      display: flex;
      flex-wrap: wrap;
      gap: 40px;
      justify-content: center;
      margin-bottom: 40px;
    }
    .ap-feature {
      background: var(--blue-light);
      border-radius: 18px;
      box-shadow: 0 2px 16px rgba(10,102,194,0.06);
      padding: 32px 24px;
      min-width: 260px;
      max-width: 340px;
      flex: 1 1 260px;
      text-align: left;
      margin-bottom: 10px;
      color: var(--grey-main);
    }
    .ap-feature h3 {
      color: var(--blue-main);
      font-size: 1.15em;
      margin-bottom: 10px;
      font-weight: 700;
    }
    .ap-feature ul {
      margin: 0 0 0 18px;
      padding: 0;
      color: var(--blue-dark);
      font-size: 1em;
    }
    .ap-feature li {
      margin-bottom: 8px;
    }
    .ap-benefits-row {
      display: flex;
      flex-wrap: wrap;
      gap: 36px;
      justify-content: center;
      margin-bottom: 40px;
    }
    .ap-benefit {
      background: var(--white);
      border-radius: 16px;
      box-shadow: 0 2px 8px rgba(10,102,194,0.04);
      padding: 26px 22px;
      min-width: 220px;
      max-width: 320px;
      flex: 1 1 220px;
      text-align: center;
      color: var(--blue-dark);
      font-size: 1.08em;
      font-weight: 600;
    }
    .ap-benefit span {
      display: block;
      font-size: 1.8em;
      margin-bottom: 8px;
    }
    .cta-section {
      background: var(--white);
      text-align: center;
      padding: 70px 0 70px 0;
    }
    .cta-section h2 {
      color: var(--blue-main);
      font-size: 2rem;
      margin-bottom: 18px;
      font-weight: 700;
    }
    .cta-section .cta-main {
      background: var(--blue-main);
      color: var(--white);
      border-radius: 24px;
      padding: 16px 46px;
      font-size: 1.1rem;
      font-weight: 700;
      border: none;
      cursor: pointer;
      margin: 0 10px;
      transition: background 0.15s;
      box-shadow: 0 2px 16px rgba(10,102,194,0.06);
    }
    .cta-section .cta-main:hover {
      background: var(--blue-dark);
    }
    .ap-how-row {
      display: flex;
      flex-wrap: wrap;
      gap: 32px;
      justify-content: center;
      margin-bottom: 40px;
    }
    .ap-how-step {
      background: var(--blue-light);
      border-radius: 14px;
      padding: 30px 18px;
      min-width: 220px;
      max-width: 320px;
      text-align: center;
      color: var(--blue-dark);
      flex: 1 1 220px;
      box-shadow: 0 2px 8px rgba(10,102,194,0.04);
    }
    .ap-how-step h4 {
      color: var(--blue-main);
      margin-bottom: 10px;
      font-size: 1.12em;
      font-weight: 700;
    }
    .ap-integrations {
      text-align: center;
      margin: 40px 0 0 0;
      color: var(--blue-main);
      font-size: 1.1em;
    }
    .ap-integrations img {
      height: 32px;
      margin: 0 14px;
      vertical-align: middle;
    }
    footer {
      background: var(--off-white);
      padding: 40px 0;
      text-align: center;
      font-size: 1rem;
      color: var(--blue-muted);
      border-top: 1px solid var(--blue-light);
      letter-spacing: 0.1px;
    }
    @media (max-width: 1000px) {
      .ap-features-row, .ap-benefits-row, .ap-how-row { flex-direction: column; align-items: center; }
      .section { padding: 0 8px; }
    }
  </style>
</head>
<body>

  <section class="hero">
    <h1>Accounts Payable Automation</h1>
    <p>
      Automate your AP process from bill capture to global payments. Lusid streamlines approvals, ensures compliance, and saves your team hours every week.
    </p>
    <button class="cta-main" onclick="window.location='/contact-us'">Request Demo</button>
  </section>

  <section class="section" id="ap-features">
    <div class="section-title">Why Lusid for Accounts Payable?</div>
    <div class="ap-features-row">
      <div class="ap-feature">
        <h3>Automated Bill Capture</h3>
        <ul>
          <li>Email, upload, or drag-and-drop bills</li>
          <li>AI-powered data extraction</li>
          <li>Auto-categorization & vendor matching</li>
        </ul>
      </div>
      <div class="ap-feature">
        <h3>Custom Approvals & Controls</h3>
        <ul>
          <li>Multi-level, custom approval workflows</li>
          <li>Role-based permissions</li>
          <li>Audit trails for compliance</li>
        </ul>
      </div>
      <div class="ap-feature">
        <h3>Global Payments</h3>
        <ul>
          <li>Pay in USD or 34 local currencies</li>
          <li>180+ countries supported</li>
          <li>Multiple payment speeds</li>
        </ul>
      </div>
    </div>
  </section>

  <section class="section" id="ap-benefits">
    <div class="section-title">Benefits</div>
    <div class="ap-benefits-row">
      <div class="ap-benefit">
        <span>⏱️</span>
        Save hours every week with automated data entry and payment runs.
      </div>
      <div class="ap-benefit">
        <span>🔒</span>
        Reduce risk and fraud with built-in controls and full audit trails.
      </div>
      <div class="ap-benefit">
        <span>🌍</span>
        Pay vendors anywhere, in their currency, with competitive FX rates.
      </div>
      <div class="ap-benefit">
        <span>📈</span>
        Real-time visibility into cash flow and outstanding liabilities.
      </div>
    </div>
  </section>

  <section class="section" id="ap-how">
    <div class="section-title">How Lusid AP Works</div>
    <div class="ap-how-row">
      <div class="ap-how-step">
        <h4>1. Capture & Code Bills</h4>
        <p>AI extracts and codes invoice data automatically. Review and edit as needed.</p>
      </div>
      <div class="ap-how-step">
        <h4>2. Approve with Confidence</h4>
        <p>Route bills through custom approval workflows. Every step is logged for compliance.</p>
      </div>
      <div class="ap-how-step">
        <h4>3. Pay Globally</h4>
        <p>Pay vendors via ACH, wire, or international transfer. Choose payment speed and currency.</p>
      </div>
      <div class="ap-how-step">
        <h4>4. Sync & Reconcile</h4>
        <p>Bi-directional sync with your accounting system. Auto-reconcile payments and keep books up-to-date.</p>
      </div>
    </div>
    <div class="ap-integrations">
      <strong>Integrates with:</strong>
      <img src="https://busybusy.com/wp-content/uploads/2022/12/QuickBooks-Desktop-logo2.png" alt="QuickBooks Desktop" title="QB Desktop">
      <img src="https://busybusy.com/wp-content/uploads/2022/06/QuickBooks-Online-Logo.png" alt="QuickBooks Online" title="QB Online">
      <img src="https://upload.wikimedia.org/wikipedia/en/9/9f/Xero_software_logo.svg" alt="Xero" title="Xero">
    </div>
  </section>

  <section class="cta-section" id="contact">
    <h2>Ready to automate your accounts payable?</h2>
    <button class="cta-main" onclick="window.location='/contact-us'">Contact Us</button>
  </section>

</body>
</html>
` }} />
  )
}

export default AccountsPayablePage;